import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>August Wine Dinner</h1>
                <h2 className={classes.bold}>
                  August 20th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $60 Per Guest
                </h2>
                <h3>Hosted by Alabama Crown</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>


          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>                
                <h5>First Course</h5>
                <h4>Italian Crab Salad</h4>
                <p>Lump Crab, Marinated Mozzarella Balls, Heirloom Tomatoes, Pepperoncinis, Bibb Lettuce, and Red Wine Vinaigrette</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Santa Marina · Prosecco</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Smoked Salmon of the Angels </h4>
                <p>Angel Hair Pasta with Smoked Salmon, Asparagus, and Portabello Mushrooms in a Light, Fresh Dill Cream Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Villa Sparina · Gavi Del Comune Di Gavi · 2024</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Slow-Braised Short Rib Stack</h4>
                <p>Slow-Braised Short Ribs, Served Over a Manchego Polenta Cake with Sautéed Spinach, Finished with a Short Rib Jus Reduction and Crispy Leeks</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Castello Banfi · Toscana Centine Rosso · 2017</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Raspberry Panna Cotta</h4>
                <p>Topped with Raspberry Sauce and Chopped Pistachios</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Villa Pozzi Moscato · 2024</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner